
import {of as observableOf, Observable} from 'rxjs';
import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {HttpClient} from "@angular/common/http";

@Injectable()
export class CommentsResolver implements Resolve<any> {
    constructor(
        private http: HttpClient
    ) {}

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any>|Promise<any>|any {
        const isNationalTeamPage = !!route.queryParams['isNationalTeamPage'];
        if (!isNationalTeamPage) {
            return this.http.get('/api/v1/pages/' + route.params['pageID'] + '/comments');
        } else {
            // There is no comment functionality needed for national teams pages
            return observableOf({});
        }
    }
}